import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const table: SxProps<Theme> = {
  width: "100%",
  borderCollapse: "collapse",
};

export const th: SxProps<Theme> = {
  fontSize: "0.78125rem",
  fontWeight: 600,
  color: "text.secondary",
  textAlign: "start",
  pb: 1.25,
  px: 0.5,
};

export const td: SxProps<Theme> = (theme) => ({
  fontSize: "0.84375rem",
  color: "text.primary",
  py: 1.625,
  px: 0.5,
  borderTop: `1px solid ${theme.palette.divider}`,
  verticalAlign: "middle",
});

export const productCell: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
};

export const tdProductName: SxProps<Theme> = (theme) => ({
  fontSize: "0.84375rem",
  color: "text.primary",
  py: 1.625,
  px: 0.5,
  borderTop: `1px solid ${theme.palette.divider}`,
  verticalAlign: "middle",
  fontWeight: 600,
});

export const tdCategory: SxProps<Theme> = (theme) => ({
  fontSize: "0.84375rem",
  color: "text.secondary",
  py: 1.625,
  px: 0.5,
  borderTop: `1px solid ${theme.palette.divider}`,
  verticalAlign: "middle",
});

export const tdAmount: SxProps<Theme> = (theme) => ({
  fontSize: "0.84375rem",
  color: "text.primary",
  py: 1.625,
  px: 0.5,
  borderTop: `1px solid ${theme.palette.divider}`,
  verticalAlign: "middle",
  fontWeight: 600,
});

export const stockTd =
  (color: string): SxProps<Theme> =>
  (theme) => ({
    fontSize: "0.84375rem",
    color,
    py: 1.625,
    px: 0.5,
    borderTop: `1px solid ${theme.palette.divider}`,
    verticalAlign: "middle",
    fontWeight: 600,
    textAlign: "center",
  });

export const actionsCell: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
};

export const iconButton: SxProps<Theme> = (theme) => ({
  width: 34,
  height: 34,
  borderRadius: 1.125,
  border: `1px solid ${theme.palette.divider}`,
  bgcolor: "background.paper",
  color: "text.secondary",
  p: 0,
  transition: "all 0.2s ease",
  "&:hover": {
    bgcolor: alpha(theme.palette.primary.main, 0.08),
    color: "primary.main",
    borderColor: alpha(theme.palette.primary.main, 0.3),
  },
});

export const iconButtonDanger: SxProps<Theme> = (theme) => ({
  width: 34,
  height: 34,
  borderRadius: 1.125,
  border: `1px solid ${theme.palette.divider}`,
  bgcolor: "background.paper",
  color: "text.secondary",
  p: 0,
  transition: "all 0.2s ease",
  "&:hover": {
    bgcolor: alpha(theme.palette.error.main, 0.1),
    color: "error.main",
    borderColor: theme.palette.error.main,
  },
});

export const loadingWrap: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  py: 6,
};

export const desktopTable =
  (layout: "responsive" | "desktop" | "mobile" = "responsive"): SxProps<Theme> =>
  () => ({
    display:
      layout === "desktop"
        ? "block"
        : layout === "mobile"
          ? "none"
          : { xs: "none", md: "block" },
  });

export const mobileList =
  (layout: "responsive" | "desktop" | "mobile" = "responsive"): SxProps<Theme> =>
  (theme) => ({
    display: layout === "mobile" ? "flex" : layout === "desktop" ? "none" : { xs: "flex", md: "none" },
    flexDirection: "column",
    gap: theme.spacing(1.375),
  });

export const mobileCard: SxProps<Theme> = (theme) => ({
  p: theme.spacing(1.625, 1.75),
  borderRadius: 2,
  border: `1px solid ${theme.palette.divider}`,
  bgcolor: "background.paper",
  boxShadow: theme.shadows[1],
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.625),
});

export const mobileInfo: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gap: 0.5,
};

export const mobileTopRow: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
};

export const mobileBottomRow: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
};

export const mobilePrice: SxProps<Theme> = {
  fontSize: "0.8125rem",
  fontWeight: 700,
};

export const mobileCurrency: SxProps<Theme> = {
  fontSize: "0.65625rem",
  fontWeight: 500,
  color: "text.secondary",
};

export const mobileStock: SxProps<Theme> = {
  fontSize: "0.71875rem",
  color: "text.secondary",
};
